import ContactUs from 'components/pages/ContactUs/ContactUs';
import { buildPage } from 'utils/pageHelper';
export default buildPage(ContactUs, {
  fullPage: true,
  metaData: {
    title: 'Contact',
    description:
      'Got a question? Contact our dedicated & friendly customer support team - rated excellent for customer support.',
  },
});
